import axios from "axios";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "https://bird5gw.i2soft.net/",
  timeout: 15000,
});

if (!service.defaults.baseURL) {
  console.warn("警告：baseURL 未正确设置，可能导致请求失败");
}

/**
 * 封装请求方法
 * @param {string} url - 请求地址
 * @param {string} method - 请求方法(get/post/put/delete等)
 * @param {object} params - URL参数(get请求)
 * @param {object} data - 请求体数据(post请求)
 * @param {object} options - 其他axios配置项
 * @returns {Promise} 返回请求Promise
 */
const request = ({ url, method = "get", params, data, ...options }) => {
  const validMethods = ["get", "post", "put", "delete", "patch"];
  if (!validMethods.includes(method.toLowerCase())) {
    return Promise.reject(new Error(`不支持的请求方法: ${method}`));
  }

  return service({
    url,
    method,
    params,
    data,
    ...options,
  });
};

export const http = {
  get: (url, params = {}, options = {}) => request({ url, method: "get", params, ...options }),
  post: (url, data = {}, options = {}) => request({ url, method: "post", data, ...options }),
  put: (url, data = {}, options = {}) => request({ url, method: "put", data, ...options }),
  delete: (url, params = {}, options = {}) => request({ url, method: "delete", params, ...options }),
};

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.error("请求错误:", error);
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (typeof res !== "object" || res === null) {
      return Promise.reject(new Error("响应数据格式错误"));
    }

    if (res.code !== "S000000") {
      const msg = res.message || "请求失败";
      return Promise.reject(new Error(msg));
    }

    return res.data;
  },
  (error) => {
    console.error("响应错误:", error);
    return Promise.reject(error);
  },
);

export { request };
export default service;
